<script setup lang="ts">
import ExclamationIcon from '@/assets/svg/exclamation-circle-16.svg?component';
const props = defineProps<{
  rows?: number | string;
}>();
</script>
<template>
  <v-textarea
    v-bind="$attrs"
    variant="plain"
    density="compact"
    no-resize
    color="tint-80"
    autocomplete="off"
    :rows="props.rows"
  >
    <template v-slot:message="{ message }">
      <div class="mt-[1-px] flex !text-critical-500">
        <ExclamationIcon /> <span class="ml-2 place-self-center">{{ message }}</span>
      </div>
    </template>
  </v-textarea>
</template>

<style scoped lang="postcss">
:deep(.v-field__input::placeholder) {
  @apply !text-shade-800 opacity-100;
}
:deep(.v-field__input::-moz-placeholder) {
  @apply !text-shade-800 opacity-100;
}
:deep(.v-field__input::-ms-input-placeholder) {
  @apply !text-shade-800 opacity-100;
}

:deep(.v-field__input) {
  @apply w-full resize-none rounded-md border border-tint-80 px-4 py-4;
  @apply font-sans text-sm text-shade-900 transition-colors;
  @apply placeholder:text-shade-800 focus:border-highlight-500;
  @apply focus:outline-none;
  mask-image: none;
}
:deep(.v-field--error .v-field__input) {
  @apply !border-critical-500;
}
:deep(.v-input--error .v-messages) {
  @apply !text-critical-500;
}
</style>
